import React, { PureComponent } from 'react';

import PriceChangesFilters from './PriceChangeFilters';
import Auth from '../../../libs/Auth';

class PriceChangesView extends PureComponent {
  constructor(props){
    super(props);
    this.state = {
      expanded: {}
    }
  }
  toggle(id){
    const { expanded } = this.state;
    this.setState({
      expanded: {
        ...expanded,
        [id]: !expanded[id]
      }
    });
  }
  render() {
    let {
      priceChanges,
      page,
      nextPage,
      previousPage,
      importPriceChangeCSV,
    } = this.props;

    return (
      <div className="admin-priceChanges-view">
        <PriceChangesFilters {...this.props} />
        <div className="page">
          <div className="actions">
            <button onClick={() => importPriceChangeCSV()} className="button" type="button">Import PriceChanges</button>
          </div>
          <table>
            <thead>
            <tr>
              <th>oldPrice</th>
              <th>newPrice</th>
              <th>created</th>
              <th>SKU</th>
              <th>title</th>
              <th></th>
            </tr>
            </thead>

            {priceChanges.map((priceChange, i)=>(
              <tbody key={priceChange._id}>
              <tr className={i%2 ? 'even' : 'odd'}>
                <td>{priceChange.oldPrice}</td>
                <td>{priceChange.newPrice}</td>
                <td>{priceChange.created}</td>
                <td>{priceChange.SKU}</td>
                <td>{priceChange.title}</td>
                <td>
                  <div className="action-buttons">
                    <button onClick={() => this.toggle(priceChange._id)}><i className="fi-arrows-out size-18"></i> view more</button>
                  </div>
                </td>
              </tr>
              {this.state.expanded[priceChange._id] && (
                <tr>
                  <td colSpan="10">
                    Expanded content
                  </td>


                </tr>
              )}
              </tbody>
            ))}
            <tbody>
            <tr>
              <td colSpan="13">
                <ul className="pagination">
                  <li className={page <= 1 ? 'pagination-previous disabled' : 'pagination-previous'}>
                    {page > 1  ? (
                      <a onClick={e=>{
                        e.preventDefault();
                        previousPage();
                      }}>Previous</a>
                    ) : 'Previous'}

                  </li>
                  <li>{page}</li>
                  <li className="pagination-next">
                    <a onClick={e=>{
                      e.preventDefault();
                      nextPage();
                    }}>Next</a>
                  </li>
                </ul>
              </td>
            </tr>

            </tbody>
          </table>
        </div>

      </div>
    );
  }
}

export default PriceChangesView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/PriceChanges.view.js